import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { topicLinkTopic$key } from "~/queries/__generated__/topicLinkTopic.graphql";

import { StyledEntityLink } from "./styles";

export type Props = {
  className?: string;
  onClick?: (name: string) => void;
  reference: topicLinkTopic$key;
};

export const TopicLink: FunctionComponent<Props> = ({
  className,
  onClick,
  reference: reference_,
}) => {
  const topic = useFragment(
    graphql`
      fragment topicLinkTopic on Topic {
        ...entityLink
        name
      }
    `,
    reference_,
  );

  return (
    <StyledEntityLink
      className={className}
      reference={topic}
      onClick={() => {
        onClick?.(topic.name);
      }}
    >
      {topic.name}
    </StyledEntityLink>
  );
};

TopicLink.displayName = "TopicLink";
